var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileShield2Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 7.5V3.333h-7.5v13.334h5.047c.272.347.603.654.983.904l1.158.762H3.328a.827.827 0 0 1-.828-.826V2.493c0-.447.374-.826.835-.826h9.162l5.003 5V7.5h-5.833ZM10 9.167h7.5v4.957c0 .826-.418 1.597-1.113 2.055l-2.637 1.736-2.637-1.736A2.461 2.461 0 0 1 10 14.124V9.167Zm1.667 4.957c0 .264.134.512.363.663l1.72 1.132 1.72-1.132a.795.795 0 0 0 .363-.663v-3.29h-4.166v3.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileShield2Line);
export default __webpack_public_path__ + "static/media/file-shield-2-line.5255cf602943b1448153cb4b8c146ddd.svg";
export { ForwardRef as ReactComponent };